import { Store } from '@ngxs/store';
import { PublishNewBrickDefinitions } from '../store/dashboard/brick-wall/brick-definition/brick-definition.actions';
import moment from 'moment';
import { BrickRegistry } from '../components/bricks/brick.registry';

export function brickDefinitionsLoader(store: Store): void {
   store.dispatch(new PublishNewBrickDefinitions(BrickRegistry.brickSpecifications().map((x) => x.definition)));
}

export function configureMoments() {
   moment.relativeTimeThreshold('s', 59);
   moment.relativeTimeThreshold('m', 59);
   moment.relativeTimeThreshold('h', 23);
   moment.relativeTimeThreshold('ss', 1);
}
